import {KeyboardEvent} from 'react';

export function randomString(): string {
    return (Math.random() + 1).toString(10).substring(4);
}

export function blurOnEnter(e: KeyboardEvent<HTMLInputElement>): void {
    if (e.key === 'Enter') {
        e.currentTarget.blur();
    }
}

export function getCurrentYear(): number {
    return new Date().getFullYear();
}

export function compareByValue(a: {value: number}, b: {value: number}): number {
    if (a.value < b.value) {
        return 1;
    }
    if (a.value > b.value) {
        return -1;
    }
    return 0;
}

export function removeHtmlTagsAndSpaces(inputString: string): string | null {
    if (!inputString || inputString.trim() === '') {
        return null;
    }

    return inputString.replace(/<[^>]*>/g, '').trim();
}
